import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';
import PublicAIChatModal from './PublicAIChatModal';

export default function PublicAIInput({ tenantId, tenantName }) {
  const [showModal, setShowModal] = useState(false);
  const [initialQuery, setInitialQuery] = useState('');
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim()) {
      setInitialQuery(inputValue.trim());
      setShowModal(true);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <>
      {/* Prominent AI Input Field */}
      <div className="w-full max-w-2xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="relative"
        >
          {/* Gradient border effect */}
          <div 
            className="absolute inset-0 rounded-2xl opacity-75 blur-sm"
            style={{
              background: 'linear-gradient(135deg, #f97316, #ec4899, #8b5cf6)',
              padding: '2px',
            }}
          />
          
          <form onSubmit={handleSubmit} className="relative">
            <div className="relative bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
              <div className="flex items-center gap-3 p-2">
                {/* AI Icon */}
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-r from-orange-500 to-pink-500 flex items-center justify-center ml-2">
                  <Sparkles className="w-6 h-6 text-white" />
                </div>
                
                {/* Input Field */}
                <input
                  type="text"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Ask me anything about our services..."
                  className="flex-1 h-14 px-4 text-lg bg-transparent border-0 focus:outline-none focus:ring-0 placeholder:text-gray-400"
                  data-testid="public-ai-input"
                />
                
                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={!inputValue.trim()}
                  className={`flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center mr-2 transition-all ${
                    inputValue.trim()
                      ? 'bg-gradient-to-r from-orange-500 to-pink-500 text-white hover:shadow-lg hover:scale-105'
                      : 'bg-gray-100 text-gray-400'
                  }`}
                  data-testid="public-ai-submit"
                >
                  <ArrowRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          </form>
        </motion.div>
        
        {/* Helper Text */}
        <p className="text-center text-sm text-gray-500 mt-4">
          Get instant answers about our services, pricing, and recommendations
        </p>
      </div>

      {/* Chat Modal */}
      <PublicAIChatModal
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
          setInputValue('');
        }}
        initialQuery={initialQuery}
        tenantId={tenantId}
        tenantName={tenantName}
      />
    </>
  );
}
